/** FOC product-tour display labels (leaf module — no app imports). */

export const FOC_TOUR_LABEL_ORG_WORKSPACE =
  '4.1 Organizational Workspace Model';

export const FOC_TOUR_LABEL_PLANNING =
  '4.3 Planning Repository and Pre-Incident Planning';

export const FOC_TOUR_LABEL_HUB_COP =
  '5.1–5.2 Common Operating Picture — The Hub';

export const FOC_TOUR_LABEL_SITL_COP =
  '5.3 Incident-Level SITL COP Workspace';

export const FOC_TOUR_LABEL_COP_LAYERS =
  '5.4–5.5 Layers, Data, and Hierarchical COP';

export const FOC_TOUR_LABEL_FSLTP =
  '5.6 FSLTP and ArcGIS Online Integration';

export const FOC_TOUR_LABEL_NOTIFICATIONS = '6.1 Notification Management';

export const FOC_TOUR_LABEL_INCIDENTS = '7.1 Incident Management';

export const FOC_TOUR_LABEL_INCIDENT_ROSTER = '7.2 Incident Roster';

export const FOC_TOUR_LABEL_INITIAL_RESPONSE =
  '8.1–8.4 Initial Response / ICS 201';

export const FOC_TOUR_LABEL_TRANSITION = '9.1 Transition to Planning P';

export const FOC_TOUR_LABEL_PLANNING_P_MODEL =
  '10.1 Planning P Operating Model';

export const FOC_TOUR_LABEL_PLANNING_P_MEETING =
  '10.2 Planning P Meeting Management';

export const FOC_TOUR_LABEL_PLANNING_P_COMMAND_STAFF =
  '10.3 Command and General Staff Meeting';

export const FOC_TOUR_LABEL_PLANNING_P_PREP_TACTICS =
  '10.4 Prep for Tactics Workspace';

export const FOC_TOUR_LABEL_PLANNING_P_TACTICS_WORKFLOW =
  '10.5 Tactics, Resource, and Safety Workflow';

export const FOC_TOUR_LABEL_PLANNING_P_TACTICS_MEETING =
  '10.6 Tactics Meeting';

export const FOC_TOUR_LABEL_PLANNING_PREP_MEETING =
  '11.1–11.2 Prep for Planning & Planning Meeting';

export const FOC_TOUR_LABEL_IAP_PREP_OPS =
  '12.1–12.3 IAP Prep, Approval & Operations Brief';

export const FOC_TOUR_LABEL_IAP_FORMS =
  '12.4 ICS Form Lifecycle, Coverage & Export';

export const FOC_TOUR_LABEL_WS = '13.1 Role-Based Incident Workspaces';

export const FOC_TOUR_LABEL_CMD_IC =
  '14.1 Incident Commander / Unified Command Workspace';

export const FOC_TOUR_LABEL_CMD_SAFETY = '14.2 Safety Officer Workspace';

export const FOC_TOUR_LABEL_CMD_LIAISON = '14.3 Liaison Officer Workspace';

export const FOC_TOUR_LABEL_CMD_PIO =
  '14.4 Public Information Officer Workspace';

export const FOC_TOUR_LABEL_CMD_LEGAL = '14.5 Legal Officer Workspace';

export const FOC_TOUR_LABEL_PLN_PSC =
  '15.1 Planning Section Chief Workspace';

export const FOC_TOUR_LABEL_PLN_SITL = '15.2 Situation Unit Workspace';

export const FOC_TOUR_LABEL_PLN_RESOURCE = '15.3 Resource Unit Workspace';

export const FOC_TOUR_LABEL_PLN_DOCS =
  '15.4 Documentation Unit Workspace';

export const FOC_TOUR_LABEL_PLN_DEMOB =
  '15.5 Demobilization Unit Workspace';

export const FOC_TOUR_LABEL_OPS = '16 Operations Section Workspace';

export const FOC_TOUR_LABEL_LOG =
  '17.1 Persistent Logistics Capability';

export const FOC_TOUR_LABEL_RES_MODEL =
  '20.1 Resource Management Terminology and Model';

export const FOC_TOUR_LABEL_RES_213RR = '20.2 Resource Requests / ICS 213RR';

export const FOC_TOUR_LABEL_RES_211 =
  '20.3 Check-In, Check-Out, and ICS 211';

export const FOC_TOUR_LABEL_RES_214 = '20.4 ICS 214 Activity Log';

export const FOC_TOUR_LABEL_DMOB = '21 Demobilization';

export const FOC_TOUR_LABEL_EXT =
  '22 External User Onboarding, Management, and Collaboration';

export const FOC_TOUR_LABEL_AI_IOC = '23.1 IOC Carryover Requirements';

export const FOC_TOUR_LABEL_AI_FOC = '23.2 FOC AI Requirements';
